import { render, staticRenderFns } from "./Arrow-right.vue?vue&type=template&id=f547844c&scoped=true"
import script from "./Arrow-right.vue?vue&type=script&lang=js"
export * from "./Arrow-right.vue?vue&type=script&lang=js"
import style0 from "./Arrow-right.vue?vue&type=style&index=0&id=f547844c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f547844c",
  null
  
)

export default component.exports